// Installed V1 SQPurchasedItemDialog receives og(cg(resolvedTier)) on creation.
// This snapshot is deliberately separate from existing-row editor fallback.
export function purchaseCreationMargin(quote, customer, options) {
  const approval=options?.approval;
  const key=quote?.tier_override || customer?.tier || approval?.default_tier;
  const markup=approval?.tiers?.[key]?.markup_pct;
  if(typeof markup!=='number'||!Number.isFinite(markup)||markup<0) return null;
  return markup<=0 ? 0 : Math.min(95,Number((markup/(100+markup)*100).toFixed(1)));
}

export function newPurchaseValues(item) {
  return {unit_cost_cents:item.unit_cost_cents,description:item.description||item.label,
    margin_pct:Number(item.margin_pct.toFixed(2)),...(item.item_type?{item_type:item.item_type}:{}),...(item.blank?{blank:item.blank}:{})};
}
